// extracted by mini-css-extract-plugin
module.exports = {"formWrapper":"customerAccountRegistrationForm_formWrapper__1DBKB"};